module.exports = __webpack_public_path__ + "static/media/Vampire Bat.5e6da498.jpg";